<template>
  <div>
    <HeaderBar :title="hTitle" />
    <div
      v-for="(item, i) in items"
      :key="i"
      class="my-4 text-xl text-justify border-b border-gray-300 pb-10"
    >
      {{ item.content }}
    </div>
  </div>
</template>
<script>
import HeaderBar from "../../components/HeaderBar.vue";
export default {
  components: { HeaderBar },
  props: ["hTitle"],
  data() {
    return {
      items: [
        { id:1,
          content:
            "The remaining balance of your Total Contract Price will be payable based on your chosen and approved payment terms. This is a type of loan with scheduled, periodic payments that are applied to both the loan;s principal amount and the interest accrued.",
        },
        { id:2,
          content:
            "An amortized loan payment first pays off the interest expense for the period; any remaining amount is put towards reducing the principal amount.",
        },
        { id:3,
          content:
            "As the interest portion of the payments for an amortization loan decreases, the principal portion increases.",
        },
        { id:4,
          content:
            "Regardless of the application of interest and principal, your Monthly Amortization will retain with a fixed monthly amount or as otherwise indicated in your payment terms.",
        },
      ],
    };
  },
};
</script>